import hexToRgba from 'hex-to-rgba';
import React from 'react';
import { useTheme } from 'styled-components';
import _, { random } from 'underscore';

const colors = [
  '#1E90FF', '#32CD32', '#FF69B4', '#FFA500', '#9370DB',
  '#20B2AA', '#FF6347', '#4169E1', '#DA70D6', '#3CB371'
];

export const InitialCircle = ({ name, size = 40, useFirstWordOnly = false, colorInd, logoUrl, bgOpacity, border }) => {
    const theme = useTheme()
    const colors = theme.colors.chart
    const initials = useFirstWordOnly
        ? (name || '').charAt(0).toUpperCase()
        : (name || '')
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);

    const colorIndex = !_.isNumber(colorInd) ? random(colors.length-1) : colorInd;
    const backgroundColor = hexToRgba(colors[colorIndex], bgOpacity || 0.3);

    return (
        <div
            title={name}
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: hexToRgba(theme.colors.secondary, 0.7),
                fontWeight: 'bold',
                fontSize: `${size * 0.4}px`,
                overflow: 'hidden', // Add this to ensure the image stays within the circle
                position: 'relative',
                border: border || `0.01px solid ${hexToRgba(theme.colors.primary2, 0.5)}`
            }}
        >
            {logoUrl ? (
                <img
                    src={logoUrl}
                    alt={`${name} logo`}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                    }}
                />
            ) : (
                initials
            )}
        </div>
    );
};